import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import Paper from '@mui/material/Paper';
import PropTypes from 'prop-types';
import { Map } from 'immutable';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';

import NotesList from 'src/component/UI/NotesList';
import Button from 'src/component/UI/Button';
import LoadingSpinner from 'src/component/UI/LoadingSpinner';
import { fetchDevicesActiveNotes, fetchDevicesArchivedNotes } from 'src/module/device/action';
import { getDevicesActiveNotes, getLoadingActiveNotes, getNumActiveNotesPages, getTotalActiveNotes, getDevicesArchivedNotes, getLoadingArchivedNotes, getNumArchivedNotesPages, getTotalArchivedNotes } from 'src/module/device/selector';
import { getDevicesSelectedFilters } from 'src/module/filter/selector';
import { fetchNotesExport, clearNotesExport } from 'src/module/note/action';
import { getDevice } from 'src/module/device/selector';
import { getLoadingExportNotes } from 'src/module/note/selector';
import useMediaQuery from '@mui/material/useMediaQuery';
import DeviceRotate from 'src/component/UI/DeviceRotate';
import variables from 'src/style/variable/variables.module.scss';

export default function NotesContent (props) {

  const {
    title,
    deviceId,
    isExpanable,
    onlyArchived,
    showDeleteIcon
  } = props;

  const dispatch = useDispatch();
  const selectedFilters = useSelector(getDevicesSelectedFilters);
  const loadingExportNotes: any = useSelector(getLoadingExportNotes);
  const device: any = useSelector(getDevice(deviceId));
  const parentTag = device?.get('parent_type') === 'controller' ? device?.get('controller_tag') : null;
  const deviceTag = parentTag ? `${parentTag}-${device?.get('tag')}` : device?.get('tag');

  const [pastNotesCollapsed, setPastNotesCollapsed] = useState(!isExpanable);

  useEffect(() => {
    dispatch(clearNotesExport());
  }, []);

  const iconStyles = { color: variables.primarySolid };

  const handleExport = () => {
    dispatch(fetchNotesExport(selectedFilters, Map(), 'all', deviceId, deviceTag, false));
  };

  const selectorsActive = {
    getNotes: getDevicesActiveNotes(deviceId),
    getLoadingNotes: getLoadingActiveNotes(deviceId),
    getNumNotesPages: getNumActiveNotesPages(deviceId),
    getTotalNotes: getTotalActiveNotes(deviceId)
  };
  const selectorsArchived = {
    getNotes: getDevicesArchivedNotes(deviceId),
    getLoadingNotes: getLoadingArchivedNotes(deviceId),
    getNumNotesPages: getNumArchivedNotesPages(deviceId),
    getTotalNotes: getTotalArchivedNotes(deviceId)
  };

  const makeTogglePastNotesGroup = () => {
    setPastNotesCollapsed(!pastNotesCollapsed);
  };
  const isMobile = useMediaQuery(`(max-width: ${variables.mobileWidth})`);
  const isPortrait = useMediaQuery('(orientation: portrait)');
  const [showRotateMessage, setShowRotateMessage] = useState(isMobile && isPortrait);
  useEffect(() => {
    setShowRotateMessage(isMobile && isPortrait);
  }, [isMobile, isPortrait]);

  return (
    <div id="notes-content" data-testid='notes-content'>
      <Paper>
        {isExpanable ?
          <h3 className='expandable' onClick={() => makeTogglePastNotesGroup()}>{title} &nbsp;<span className='expand-arrow'>{pastNotesCollapsed ? '▲' : '▼'}</span></h3>
          :
          <h3>
            {title}
            <Button loading={loadingExportNotes} spinner={<LoadingSpinner size={14} color={variables.primary}/>} onClick={() => handleExport()} icon={<FileDownloadOutlinedIcon style={iconStyles} />}></Button>
          </h3>
        }
        {!onlyArchived && !showRotateMessage? <NotesList supressSelectedFilters selectors={selectorsActive} noteType={'all'} showNoteType showSubject showAlarm showExpiry fetch={fetchDevicesActiveNotes} suppressHeader deviceId={deviceId} hideDeviceTag showDeleteIcon={showDeleteIcon} tableId='activeNotesTable'/> : ''}
        {onlyArchived && pastNotesCollapsed && !showRotateMessage? <NotesList supressSelectedFilters selectors={selectorsArchived} noteType={'all'} showNoteType showSubject showAlarm showExpiry showArchivedNotes fetch={fetchDevicesArchivedNotes} suppressHeader deviceId={deviceId} hideDeviceTag showDeleteIcon={showDeleteIcon}  tableId='pastNotesTable' /> : ''}
        {pastNotesCollapsed && showRotateMessage ?
          <DeviceRotate />
          : null}
      </Paper>
    </div>
  );
}

NotesContent.propTypes = {
  title: PropTypes.string,
  deviceId: PropTypes.string,
  isExpanable: PropTypes.bool,
  onlyArchived: PropTypes.bool,
  showDeleteIcon: PropTypes.bool,
};

NotesContent.defaultProps = {
  title: String,
  deviceId: null,
  isExpanable: false,
  onlyArchived: false,
  showDeleteIcon: false,
};
